import { Seatingplan } from "../models";
import { BoxOfficeActions, SeatingplanServerActions } from "../actions"

export interface SeatingplanServerState extends Seatingplan {
	asJson: string;
}

const initialState: SeatingplanServerState = null;


export const seatingplanServeReducer = (state = initialState, action) => {
	switch (action.type) {
		case SeatingplanServerActions.SEATINGPLAN_LOADED: {
			return action.payload;
		}

		case BoxOfficeActions.CLEAR_EVENTSERVER_STATE:
			return initialState;

		default: {
			return state;
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/reducers/seatingplan-server.reducer.ts